var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"goto"}},[(_vm.position > 250)?_c('div',{staticClass:"gotopButton",on:{"click":function($event){return _vm.toTop()}}},[_c('div',[_c('img',{attrs:{"src":require("./assets/gotop.png")}})])]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }